import {
  PaymentMethodsApiAdapter,
  PaymentMethodOption,
} from '../adapters/PaymentMethodsApiAdapter';
import { HttpClient } from '@adapters/HttpClient';

export class PaymentMethodsService {
  private adapter: PaymentMethodsApiAdapter;

  constructor(httpClient: HttpClient) {
    this.adapter = new PaymentMethodsApiAdapter(httpClient);
  }

  async getPaymentMethods(): Promise<PaymentMethodOption[]> {
    try {
      return await this.adapter.getAll();
    } catch (error) {
      console.error(
        '🔍 PaymentMethodsService - Error al obtener medios de pago:',
        error
      );
      throw error;
    }
  }
}
